import { h } from 'preact'; /** @jsx h */

import './breadcrumbs.scss';

const triangleRight = (
    <svg width="10" height="14" viewBox="0 0 15 19" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M0.583361 1.24996L0.58336 17.75C0.583883 17.917 0.629958 18.0808 0.716623 18.2236C0.803289 18.3664 0.927262 18.4829 1.0752 18.5605C1.22314 18.6381 1.38944 18.6739 1.5562 18.664C1.72297 18.6541 1.88387 18.5989 2.02161 18.5044L13.9383 10.2544C14.4324 9.91246 14.4324 9.08929 13.9383 8.74646L2.02161 0.496456C1.88416 0.400962 1.72317 0.344962 1.55613 0.33454C1.38909 0.324119 1.22239 0.359674 1.07414 0.437343C0.925885 0.515013 0.801753 0.631825 0.715229 0.775089C0.628704 0.918354 0.583097 1.08259 0.583361 1.24996ZM11.8061 9.49996L2.41669 16.001L2.41669 2.99896L11.8061 9.49996Z"
            fill="#004B8D"
        />
    </svg>
);

const Breadcrumbs = ({ slug = null }) => {
    const { pathname } = window?.location;
    const isPathnameSlug = pathname.includes(slug);

    const capitalizedLabel = slug && slug?.charAt(0).toUpperCase() + slug?.slice(1);
    const labelWithSpaces = capitalizedLabel && capitalizedLabel?.replace(/-/g, ' ');

    return (
        <div className={`ws-main-breadcrumbs ${isPathnameSlug && 'product-page'}`}>
            <div className="ws-breadcrumbs">
                <a href="/">Hjem</a>
                <span className="ws-breadcrumbs-separator">{triangleRight}</span>
                {slug ? <a href="/nettbutikk">Nettbutikk</a> : <p>Nettbutikk</p>}
                {slug && <span className="ws-breadcrumbs-separator">{triangleRight}</span>}
                {slug && isPathnameSlug && <p>{labelWithSpaces}</p>}
            </div>
        </div>
    );
};

export default Breadcrumbs;
